import { Helmet } from 'react-helmet-async';
import BreadCrumbs from '../../../components/BreadCrumbs/BreadCrumbs';
import { IoCheckmarkCircleOutline } from "react-icons/io5";
import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import { Link } from 'react-router-dom';

const JlccProgram = () => {
    return (
        <section>
            <div className='about-mijsc-section w-full bg-cover h-fit pb-5'>
                <Helmet>
                    <title>JLCC Program for Students </title>
                    <meta name="description" content="Learn more about MIJSC, our mission, vision, and commitment to excellence." />
                </Helmet>
                <section className='bg-gray-200 w-full py-2 h-[70px]'>
                    <div className='text-sm flex items-center gap-2 py-3 place-content-center'>
                        <Link to="/" className="hover:text-green-600 font-semibold">Home</Link>
                        <MdKeyboardDoubleArrowRight className='text-green-600' />
                             <Link to="/" className="hover:text-green-600 font-semibold">MIJSC Programs</Link>
                         <MdKeyboardDoubleArrowRight className='text-green-600' />
                         <Link to="/" className="hover:text-green-600 font-semibold">JLCC Program for Students</Link>
                    </div>
                </section>

                <div class="text-white space-y-3 py-5 rounded-md">
                    <div className="rounded-xl md:mx-8 mx-2 w-[95%] h-96 bg-cover bg-center transition-all duration-700"
                        style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/imgs/program-for-students.avif)` }}> </div>
                </div>

                <div className='w-full text-justify md:flex md:mx-10 md:px-0 px-3'>

                    <section className='md:w-[94%] h-fit  mb-5 ' >
                        <h2 className='md:text-2xl text-lg py-3 text-green-600 font-semibold pt-10'>Phase - 4</h2>
                        <div className='flex gap-2 items-center'>
                            <IoCheckmarkCircleOutline className='text-green-600 text-xl' />
                            <p className='text-gray-500'>  Facilitator: MIJSC @ IIMB </p>
                        </div>
                        <div className='flex gap-2 items-center'>
                            <IoCheckmarkCircleOutline className='text-green-600 text-xl' />
                            <p className='text-gray-500'>Program: Japanese Language, Conversation and Business Culture Course </p>
                        </div>
                        <div className='flex gap-2 items-center'>
                            <IoCheckmarkCircleOutline className='text-green-600 text-xl' />
                            <p className='text-gray-500'> Delivered by: Native Japanese Language Speakers </p>
                        </div>
                        <div className='flex gap-2 items-center'>
                            <IoCheckmarkCircleOutline className='text-green-600 text-xl' />
                            <p className='text-gray-500'> Timeline: 1 year each for JLCC 1 & JLCC 2 (Recommended from 3rd to 6th Sem) </p>
                        </div>
                        <div className='flex gap-2 items-center'>
                            <IoCheckmarkCircleOutline className='text-green-600 text-xl' />
                            <p className='text-gray-500'> Mode of Delivery: Language Expert (Online)+ Language Workshops (Offline) </p>
                        </div>
                        <div className='flex gap-2 items-center'>
                            <IoCheckmarkCircleOutline className='text-green-600 text-xl' />
                            <p className='text-gray-500'>Outcome: Students attain proficiency to attend JLPT N5 and N4 level test. </p>
                        </div>
                    </section>

                </div>
                <div className='mx-10'>
                    <div className='w-full my-5 text-justify md:flex bg-white shadow-md rounded-lg p-5 border-2 border-gray-200'>

                        <section className='md:w-[94%] h-full md:ml-5 mb-5 place-self-center' >
                            <p className='text-gray-600 py-1 text-sm sm:text-base'>
                                JLCC-1: Students will attain proficiency in Conversational nuances and be prepared for JLPT N5 level test.
                            </p>
                            <p className='text-gray-600 py-1 text-sm sm:text-base'>JLCC-2: Students will be familiar with Japanese Business Culture and be prepared for JLPT N4 level test. </p>
                            <p className='text-gray-600 py-1 text-sm sm:text-base'>The Japanese Language, Conversation and Business Culture’ course is a one-year study program intended to prepare professionals with the basic skills required to effectively do business in Japan. The study program is designed for students and those who are already employed, particularly in companies with an interest in Japan. Participation certificates will be awarded by MIJSC to those who complete 60 hours and attain basic skills, while those who finish all 120 hours will receive a completion certificate.</p>

                        </section>
                    </div>
                </div>



                <div className="w-[94%] text-justify md:mx-10 mx-2 md:mt-10">
                    <table className="w-full border border-gray-300 text-sm">
                        <tbody>
                            {/* Header row 1 */}
                            <tr className="bg-gray-100">
                                <th
                                    rowSpan={2}
                                    className="border border-gray-300 px-4 py-3 text-center font-semibold"
                                >
                                    Course Content
                                </th>
                                <th
                                    colSpan={4}
                                    className="border border-gray-300 px-4 py-3 text-center font-semibold"
                                >
                                    Semesters
                                </th>
                            </tr>

                            {/* Header row 2 */}
                            <tr className="bg-gray-100">
                                {[3, 4, 5, 6].map((sem) => (
                                    <th
                                        key={sem}
                                        className="border border-gray-300 px-3 py-2 text-center"
                                    >
                                        {sem}
                                    </th>
                                ))}
                            </tr>

                            {/* JLCC 1 */}
                            <tr>
                                <td className="border border-gray-300 px-4 py-3 text-center font-medium">
                                    JLCC 1
                                </td>
                                <td
                                    colSpan={2}
                                    className="border border-gray-300 bg-gray-200 px-4 py-3 text-center"
                                >
                                    Lessons by Native Japanese Speakers (Online) + Language Workshops
                                    (Offline)
                                </td>
                                <td className="border border-gray-300"></td>
                                <td className="border border-gray-300"></td>
                            </tr>

                            {/* JLCC 2 */}
                            <tr>
                                <td className="border border-gray-300 px-4 py-3 text-center font-medium">
                                    JLCC 2
                                </td>
                                <td className="border border-gray-300"></td>
                                <td className="border border-gray-300"></td>
                                <td
                                    colSpan={2}
                                    className="border border-gray-300 bg-gray-200 px-4 py-3 text-center"
                                >
                                    Lessons by Native Japanese Speakers (Online) + Language Workshops
                                    (Offline)
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </section>
    )
}

export default JlccProgram
